import React from 'react';
import { motion } from 'framer-motion';

const ModernHero = ({ data }) => {
    if (!data) return null;

    return (
        <div className="relative h-screen w-full overflow-hidden bg-agro-green">
            {/* Background Video/Image */}
            <div className="absolute inset-0 z-0 overflow-hidden">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="absolute inset-0 w-full h-full object-cover opacity-80 scale-105"
                >
                    <source src="/videos/hero-bg.mp4" type="video/mp4" />
                    {/* Fallback image if video not supported or fails */}
                    <img
                        src={data.desktop_url || "/images/sr-agro-4.jpeg"}
                        alt={data.title}
                        className="w-full h-full object-cover"
                    />
                </video>
                {/* Overlay gradient - Dark Green for better text prominence */}
                <div className="absolute inset-0 bg-gradient-to-b from-agro-green-dark/70 via-agro-green-dark/40 to-agro-green-dark/80" />
            </div>

            {/* Content */}
            <div className="relative z-10 container mx-auto px-6 h-full flex flex-col justify-center items-start pt-20 md:pt-32">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="max-w-4xl"
                >
                    <p className="text-agro-lime font-sans uppercase tracking-widest mb-4 font-semibold text-xs sm:text-sm md:text-base">
                        Integrated Poultry Farming
                    </p>
                    <h1 className="text-white font-sans font-bold text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-tight mb-6 tracking-tight">
                        {data.title || "SR Agro Farms"}
                    </h1>
                    <p className="text-gray-200 font-serif text-lg sm:text-xl md:text-2xl max-w-2xl leading-relaxed mb-10">
                        {data.subtitle || "Trusted Poultry Farming & Contract Poultry Solutions in Karnataka"}
                    </p>

                    <button
                        onClick={() => window.open('https://wa.me/919845000069', '_blank')}
                        className="bg-agro-lime text-agro-green-dark font-sans font-bold py-4 px-8 rounded-full hover:bg-white hover:scale-105 transition-all duration-300"
                    >
                        Join us in building a Nutrition India
                    </button>
                </motion.div>
            </div>

            {/* Scroll Indicator */}
            <motion.div
                className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10"
                animate={{ y: [0, 10, 0] }}
                transition={{ repeat: Infinity, duration: 2 }}
            >
                <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
                    <div className="w-1 h-3 bg-white rounded-full" />
                </div>
            </motion.div>
        </div>
    );
};

export default ModernHero;
